<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  position="top"
  [style]="{ marginTop: '5rem' }"
>
  <ng-template #headless>
    <div class="flex w-[27rem] flex-col items-center rounded-sm">
      <div class="flex w-full flex-col gap-6 p-4">
        <div class="flex justify-between">
          <svg-icon src="/assets/icons/general/ornate-warning.svg" />
          <p-button
            size="small"
            severity="contrast"
            variant="text"
            (click)="onCancel()"
          >
            <ng-template #icon>
              <svg-icon src="/assets/icons/general/close.svg" />
            </ng-template>
          </p-button>
        </div>
        <div>
          <p class="text-common-contrast typography-headings-small mb-2">
            {{ title() }}
          </p>
          <p class="typography-body-small text-text-common-base">
            {{ body() }}
          </p>
        </div>
      </div>
      <div class="flex w-full justify-end gap-3 px-4 py-3">
        <p-button
          [label]="cancelButtonLabel"
          severity="contrast"
          variant="text"
          (click)="onCancel()"
        />
        <p-button
          [label]="acceptButtonLabel"
          severity="warn"
          (click)="onConfirm()"
        />
      </div>
    </div>
  </ng-template>
</p-dialog>
